import { useEffect, useState } from "react";

const BackToTop = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const scrollContainer = document.querySelector(".mqc-home");

        const handleScroll = () => {
            if (scrollContainer?.scrollTop && scrollContainer?.scrollTop > 300) {
                setShow(true);
            } else {
                setShow(false);
            }
        };

        scrollContainer?.addEventListener("scroll", handleScroll);

        return () =>
            scrollContainer?.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        const scrollContainer = document.querySelector(".mqc-home");
        scrollContainer?.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <button
            onClick={scrollToTop} className={`btn-home back-to-top border-0 p-0 ${ show ? "show" : ""}`}
        >
            <svg width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="34" height="38" rx="11" fill="#FFC107"/>
                <rect x="1" y="1" width="34" height="38" rx="11" stroke="#FFC107" stroke-width="2"/>
                <path d="M16.657 16.414L12.707 20.364C12.5184 20.5462 12.2658 20.647 12.0036 20.6447C11.7414 20.6424 11.4906 20.5372 11.3052 20.3518C11.1198 20.1664 11.0146 19.9156 11.0123 19.6534C11.01 19.3912 11.1108 19.1386 11.293 18.95L16.95 13.293C17.0426 13.1998 17.1528 13.1259 17.2741 13.0754C17.3955 13.0249 17.5256 12.999 17.657 12.999C17.7884 12.999 17.9185 13.0249 18.0398 13.0754C18.1612 13.1259 18.2713 13.1998 18.364 13.293L24.021 18.95C24.1165 19.0422 24.1927 19.1526 24.2451 19.2746C24.2975 19.3966 24.3251 19.5278 24.3262 19.6606C24.3274 19.7934 24.3021 19.9251 24.2518 20.048C24.2015 20.1708 24.1273 20.2825 24.0334 20.3764C23.9395 20.4703 23.8278 20.5445 23.7049 20.5948C23.5821 20.6451 23.4504 20.6704 23.3176 20.6692C23.1848 20.6681 23.0536 20.6405 22.9316 20.5881C22.8096 20.5357 22.6992 20.4595 22.607 20.364L18.657 16.414L18.657 26C18.657 26.2652 18.5516 26.5196 18.3641 26.7071C18.1766 26.8946 17.9222 27 17.657 27C17.3918 27 17.1374 26.8946 16.9499 26.7071C16.7624 26.5196 16.657 26.2652 16.657 26L16.657 16.414V16.414Z" fill="#1E1E1E"/>
            </svg>
        </button>
    );
};

export default BackToTop;